/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable promise/param-names */
const scriptsMap = new Map();
export function loadScript(url: string, checkFn: () => boolean) {
  if (scriptsMap.get(url)) {
    return scriptsMap.get(url);
  }
  const script = document.createElement('script');
  script.src = url;
  document.head.appendChild(script);
  let resolve: any = null;
  let reject: any = null;
  let checking = true;
  const tick = () => {
    if (!checkFn) {
      return;
    }
    if (checkFn()) {
      resolve();
    } else if (checking) {
      setTimeout(() => tick, 50);
    }
  };

  script.onload = () => {
    script.onerror = null;
    script.onload = null;
    if (!checkFn) {
      checking = false;
      resolve();
    } else {
      tick();
    }
  };
  script.onerror = () => {
    script.onerror = null;
    script.onload = null;
    reject();
  };
  tick();
  scriptsMap.set(
    url,
    new Promise((r, j) => {
      resolve = r;
      reject = j;
    }),
  );
  return scriptsMap.get(url);
}
